import React, { useState } from 'react'
import ReportHeader from '../../../common/ReportHeader'
import { bookingMenu } from '../../../../redux/Actions'
import { useDispatch } from 'react-redux'
import { Box, Button, Divider, Grid } from '@mui/material'
import CustomDatePicker from '../../../common/CustomDatePicker'
import { formatDate, navigation1 } from '../../../../utilityFunctions'
import TextBox from '../../../common/TextBox'
import TrackTopupDetails from './TrackTopupDetails'

const TrackTopup = () => {
    const dispatch = useDispatch()

    const [filterValue, setFilterValue] = useState({
        fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
        toDate: formatDate(window.getTime ? window.getTime() : new Date()),
        code: '',
        ticketNo: '',
        refrenace: ''
    })

    const handleField = (event) => {
        setFilterValue((prev) => ({
            ...prev,
            [event.target.name]: event.target.value
        }))
    }
    const handleSearch = () => {

    }

    const handleReset = () => {
        setFilterValue((prev) => ({
            ...prev,
            fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
            toDate: formatDate(window.getTime ? window.getTime() : new Date()),
            code: '',
            ticketNo: '',
            refrenace: ''
        }))
    }
    return (
        <>
            <ReportHeader mainHeaderName="Booking" headerName={'Track Top up'} openSubMenu={() => dispatch(bookingMenu(true))} fixedTopPosition={true} defaultTopPosition={'40px'} />
            <Box>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    columnSpacing={{ xs: 1.5 }}
                    sx={{
                        padding: "16px",
                    }}
                >
                    <Grid item md={1.9} className='disabledDate'>
                        <CustomDatePicker label={'Transaction From Date'} id='fromDate' selectedDate={filterValue?.fromDate}
                            onChange={(value) => {
                                if (new Date(value) < new Date(filterValue.toDate)) {
                                    setFilterValue({ ...filterValue, fromDate: formatDate(value) })
                                } else {
                                    setFilterValue({ ...filterValue, fromDate: formatDate(value), toDate: formatDate(value) })
                                }
                            }}

                        />
                    </Grid>
                    <Grid item md={1.9} className='disabledDate'>
                        <CustomDatePicker label={'Transaction To Date'} id='toDate' selectedDate={filterValue?.toDate}
                            onChange={(value) => {
                                setFilterValue({ ...filterValue, toDate: formatDate(value) })
                            }}

                            minDate={filterValue?.fromDate}
                        />
                    </Grid>
                    <Grid item md={0.2} style={{ paddingLeft: "6px" }}>
                        <span>OR</span>
                    </Grid>
                    <Grid item md={2}>
                        <TextBox
                            type="text"
                            label="Franchisee Code"
                            value={filterValue.code}
                            onChange={handleField}
                            name="code"

                        />
                    </Grid>
                    <Grid item md={0.2} style={{ paddingLeft: "6px" }}>
                        <span>OR</span>
                    </Grid>
                    <Grid item md={2}>
                        <TextBox
                            type="number"
                            label="Ticket No"
                            value={filterValue.ticketNo}
                            onChange={handleField}
                            name="ticketNo"

                        />
                    </Grid>
                    <Grid item md={0.2} style={{ paddingLeft: "6px" }}>
                        <span>OR</span>
                    </Grid>
                    <Grid item md={2}>
                        <TextBox
                            type="text"
                            label="Ob Refrenace"
                            value={filterValue.refrenace}
                            onChange={handleField}
                            name="refrenace"

                        />
                    </Grid>
                    <Grid item md={0.8}>
                        <Button
                            id={`searchTrackTicket`}
                            variant="contained"
                            size="medium"
                            className={`btn-orange`}
                            onClick={handleSearch}

                        >
                            search
                        </Button>
                    </Grid>
                    <Grid item md={0.8}>
                        <Button
                            id={`resetButton`}
                            variant="outlined"
                            size="medium"
                            className="btn-orange-outline"
                            onClick={handleReset}

                        >
                            RESET
                        </Button>
                    </Grid>
                </Grid>
                <Divider />
                <TrackTopupDetails />
            </Box>
        </>
    )
}

export default TrackTopup